export const isPending = (trip) => {
  return (
    trip &&
    (trip.state === 2 ||
      trip.state === 3 ||
      trip.state === 4 ||
      trip.state === 21 ||
      trip.state === 90)
  );
};
